export default __webpack_public_path__ + "static/media/banner.1c552e19.svg";